import { render, staticRenderFns } from "./Votes.vue?vue&type=template&id=6694d56d&scoped=true&"
import script from "./Votes.vue?vue&type=script&lang=js&"
export * from "./Votes.vue?vue&type=script&lang=js&"
import style0 from "./Votes.vue?vue&type=style&index=0&id=6694d56d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694d56d",
  null
  
)

export default component.exports